// src/Dashboard/pages/user/Galleries/utils/galleriesUtils.js

export const PAGE_SIZE = 24;

export const DEFAULT_ALBUMS_UI = {
  q: "",
  sort: "recent", // recent | alpha | oldest
  showAll: false,
};

export const ALBUMS_UI_STORAGE_KEY = "albums_dashboard_ui_state";

export const FALLBACK_IMAGE = "/img/no-image.jpg";

export const collatorFR = new Intl.Collator("fr", { sensitivity: "base" });

export const strip = (value = "") =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();

export const stripHtml = (html = "") => {
  if (!html) return "";

  if (typeof document === "undefined") {
    return String(html)
      .replace(/<[^>]+>/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  const div = document.createElement("div");
  div.innerHTML = html;

  return (div.textContent || div.innerText || "").trim();
};

export const readStorageJson = (key, fallback) => {
  try {
    if (typeof window === "undefined") return fallback;

    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
};

export const writeStorageJson = (key, value) => {
  try {
    if (typeof window === "undefined") return;
    localStorage.setItem(key, JSON.stringify(value));
  } catch {}
};

export const onImgError = (event) => {
  if (event?.currentTarget) {
    event.currentTarget.src = FALLBACK_IMAGE;
  }
};

export const getPhotoPosition = (photo) => {
  const position = Number(photo?.position);

  return Number.isFinite(position) ? position : Number.MAX_SAFE_INTEGER;
};

export const sortPhotos = (photos = []) => {
  const arr = Array.isArray(photos) ? [...photos] : [];

  arr.sort((a, b) => {
    const pa = getPhotoPosition(a);
    const pb = getPhotoPosition(b);

    return pa - pb || Number(a?.id || 0) - Number(b?.id || 0);
  });

  return arr;
};

export const getCoverPhoto = (photos = []) => {
  const ordered = sortPhotos(photos);
  const cover = ordered.find((photo) => photo?.is_cover === true);

  return cover || ordered[0] || null;
};

export const isQuillEmpty = (html = "") => {
  const cleaned = String(html || "")
    .replace(/<p><br><\/p>/gi, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/<[^>]*>/g, "")
    .trim();

  return !cleaned;
};

export const normalizePlainText = (value = "") => {
  return String(value || "").trim().replace(/\s+/g, " ");
};

export const normalizeRichText = (value = "") => {
  const html = String(value || "").trim();

  if (isQuillEmpty(html)) return "";

  return html;
};

export const buildAlbumSearchText = (gallery) => {
  return [gallery?.titre, stripHtml(gallery?.description)]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
};